import React from "react";
import { observer } from "mobx-react-lite";
import { Show } from "Components/General/Show";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { SessionReportDocumentsTable } from "./SessionReportDocumentsTable";
import { SessionReportUploadModal } from "./SessionReportUploadModal";
import { HeaderContainer, TitleLabel, UploadButton, EmptyDocumentsContainer, AddDocLink } from "./SessionReport.styles";
import { Box, Label, theme } from "Application";

export const SessionReportDocuments: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => (
    <>
        <Box flexBox flexDirection={"column"} borderTop="1px solid #D4D4D4" p={"25px 0px"} gap="20px">
            <HeaderContainer>
                <Box display={"flex"} flexDirection={"column"} style={{ gap: "10px" }}>
                    <TitleLabel>Session doc(s)/photo(s)</TitleLabel>
                    <Show if={viewModel.model.sessionDocument.length === 0}>
                        <Label fontStyle="p">There are currently no doc(s)/photo(s) added to this session.</Label>
                    </Show>
                </Box>
                <UploadButton command={viewModel.showSessionDocPhotoCommand} displayName={"Add SESSION DOC/PHOTO"} paletteColor="primary" />
            </HeaderContainer>

            <Show if={viewModel.model.sessionDocument.length > 0}>
                <SessionReportDocumentsTable key={viewModel.model.sessionDocument.length} viewModel={viewModel} data={viewModel.sessionDocuments} />
            </Show>
        </Box>
        {viewModel.showSessionDocPhoto && <SessionReportUploadModal viewModel={viewModel} />}
    </>
));
